/**
 * VersionBadge — Consistent version/QC badges across the app.
 *
 * Usage:
 *   <VersionBadge type="version" version={1} status="approved" />
 *   <VersionBadge type="qc" version={2} status="fail" />
 */

import React from 'react';

interface VersionBadgeProps {
  type: 'version' | 'qc';
  version: number;
  status?: 'approved' | 'rejected' | 'pending' | 'unshared' | 'pass' | 'fail' | 'testing' | 'n/a' | string;
}

const getColor = (type: string, status?: string): string => {
  if (type === 'version') {
    switch (status) {
      case 'approved': return '#50c878';
      case 'rejected': return 'var(--button-danger)';
      case 'pending': return 'var(--button-warning)';
      default: return 'var(--color-accent)';
    }
  }
  // QC
  switch (status) {
    case 'pass': return '#50c878';
    case 'fail': return 'var(--button-danger)';
    case 'testing': return 'var(--button-warning)';
    default: return 'var(--color-accent)';
  }
};

const VersionBadge: React.FC<VersionBadgeProps> = ({ type, version, status }) => {
  const color = getColor(type, status);
  const label = type === 'version' ? `v${version}` : `qc${version}`;

  return (
    <span
      className="version-badge"
      style={{
        padding: '1px 5px',
        borderRadius: '3px',
        fontSize: '0.6rem',
        fontWeight: 600,
        lineHeight: '1.4',
        backgroundColor: `color-mix(in srgb, ${color} 20%, transparent)`,
        whiteSpace: 'nowrap',
        ['--badge-color' as any]: color,
      } as React.CSSProperties}
    >
      {label}
    </span>
  );
};

export default VersionBadge;
